import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, TextField, Select, MenuItem, Button, Checkbox, FormControlLabel, Divider, Slider } from "@mui/material";
import { AppContext } from "../context/AppContext";
const gemini_models_operator = [
  "gemini-2.0-flash",
  "gemini-2.0-flash-lite",
  "gemini-2.0-pro-exp-02-05",
  "gemini-2.0-flash-exp",
];
const deepseek_models_operator = [
  "deepseek-reasoner"
];
const chatgpt_models_operator = [
  "gpt-4o"
];
const claude_models_operator = [
  "claude-3-5-sonnet-20240620"
];
const SettingsPanelOperator = ({ name, api_provider, ai_agent }) => {
  const {
    AI_Agent_Model_apiProvider, setAI_Agent_Model_apiProvider,
    AI_Agent_Model_apiModel, setAI_Agent_Model_apiModel,
    AI_Agent_Model_apikey, setAI_Agent_Model_apikey
  } = useContext(AppContext);
  const [temperature_val, setTemperature_val] = useState(parseFloat(localStorage.getItem(`${name}-temperature_val`)) || 0.3);
  const [apiProvider, setApiProvider] = useState(localStorage.getItem(`${name}-apiProvider`) || (api_provider && api_provider[0]) || "Google Gemini");
  const [apiModel, setApiModel] = useState(() => {
    const storedModel = localStorage.getItem(`${name}-apiModel`);
    const defaultModels = {
      "Google Gemini": gemini_models_operator[0],
      "Deepseek": deepseek_models_operator[0],
      "OpenAI": chatgpt_models_operator[0],
      "Anthropic": claude_models_operator[0]
    };
    return storedModel || defaultModels[apiProvider] || gemini_models_operator[0];
  });
  const [apikey, setApikey] = useState(localStorage.getItem(`${name}-apikey`) || "");
  useEffect(() => {
    if (!localStorage.getItem(`AI Agent Model-apiProvider`)) {
      setAI_Agent_Model_apiProvider("Google Gemini")
      localStorage.setItem(`AI Agent Model-apiProvider`, "Google Gemini");
    }
    if (localStorage.getItem(`AI Agent Model-apiProvider`)) {
      let AI_Agent_Model_apiProvider = localStorage.getItem(`AI Agent Model-apiProvider`)
      setAI_Agent_Model_apiProvider(AI_Agent_Model_apiProvider);
    }
    if (!localStorage.getItem(`AI Agent Model-apiModel`)) {
      setAI_Agent_Model_apiModel("gemini-2.0-flash-thinking")
      localStorage.setItem(`AI Agent Model-apiModel`, "gemini-2.0-flash-thinking");
    }
    if (localStorage.getItem(`AI Agent Model-apiModel`)) {
      let AI_Agent_Model_apiModel = localStorage.getItem(`AI Agent Model-apiModel`)
      setAI_Agent_Model_apiModel(AI_Agent_Model_apiModel);
    }
    if (!localStorage.getItem(`AI Agent Model-apikey`)) {
      setAI_Agent_Model_apikey("")
      localStorage.setItem(`AI Agent Model-apikey`, "");
    }
    if (localStorage.getItem(`AI Agent Model-apikey`)) {
      let AI_Agent_Model_apikey = localStorage.getItem(`AI Agent Model-apikey`)
      setAI_Agent_Model_apikey(AI_Agent_Model_apikey);
    }
  }, []);

  return (
    <Box sx={{ width: 400, padding: 0, borderRadius: 2, backgroundColor: "trasparent", color: "black", display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ lineHeight: "-15px", marginBottom: "-10px" }}>
        <Typography variant="body2" sx={{ marginBottom: 1, fontSize: 18, fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750" }}>{name}</Typography>
        <Typography variant="body2" sx={{ marginBottom: "-2px", fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750", letterSpacing: "0px" }}>API Provider</Typography>
        <Select value={apiProvider} onChange={(e) => { setApiProvider(e.target.value); setAI_Agent_Model_apiProvider(e.target.value); localStorage.setItem(`AI Agent Model-apiProvider`, e.target.value); }} fullWidth sx={{ backgroundColor: "#808080d4", color: "#fff", borderColor: "transparent", width: "80%", height: "35px", paddingTop: "5px" }}>
          {api_provider?.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
        </Select>
      </Box>
      <Box sx={{ lineHeight: "-15px", marginBottom: "-10px" }}>
        <Typography variant="body2" sx={{ marginBottom: "-2px", fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750", letterSpacing: "0px" }}>API Key</Typography>
        <TextField type="text" value={apikey} onChange={(e) => { setApikey(e.target.value); setAI_Agent_Model_apikey(e.target.value); localStorage.setItem(`AI Agent Model-apikey`, e.target.value); }} fullWidth sx={{ "& .MuiInputBase-root": { backgroundColor: "#808080d4", color: "#fff", borderColor: "transparent", width: "98%", height: "35px", paddingTop: "5px" } }} />
      </Box>
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", fontSize: "16px", color: "rgb(75, 85, 99)" }}>
        <div style={{ fontFamily: '"Arial"', marginTop: "-3px", fontSize: "13px", color: "rgb(75, 85, 99)" }}>This key is stored locally and only used to make API requests from this extension.</div>
      </div>
      <Box sx={{ lineHeight: "-15px", marginTop: "6px", marginBottom: "-10px" }}>
        <Typography variant="body2" sx={{ marginBottom: "-2px", fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750", letterSpacing: "0px" }}>Model</Typography>
        <Select value={apiModel} onChange={(e) => { setApiModel(e.target.value); setAI_Agent_Model_apiModel(e.target.value); localStorage.setItem(`AI Agent Model-apiModel`, e.target.value); }} fullWidth sx={{ backgroundColor: "#808080d4", color: "#fff", borderColor: "transparent", width: "80%", height: "35px", paddingTop: "5px" }}>
          {apiProvider === "Google Gemini" && gemini_models_operator.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "Deepseek" && deepseek_models_operator.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "OpenAI" && chatgpt_models_operator.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "Anthropic" && claude_models_operator.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
        </Select>
        <div style={{ fontFamily: '"Arial"', marginTop: "1.2px", fontSize: "13px", color: "rgb(75, 85, 99)" }}>
          {apiProvider === "Google Gemini" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,192 tokens
            </>
          )}
          {apiProvider === "Deepseek" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,000 tokens
            </>
          )}
          {apiProvider === "OpenAI" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 16,384 tokens
            </>
          )}
          {apiProvider === "Anthropic" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,192 tokens
            </>
          )}
        </div>
      </Box>
      <Divider sx={{ backgroundColor: "#333", marginTop: ai_agent ? "10px" : "0px", marginBottom: "0px", color: "#333" }} />
    </Box>
  );
};

export default SettingsPanelOperator;